import { Routes } from '@angular/router';
import { EtxeApiParams } from '@workspace/data-types';
import { userAuthGuard } from '@workspace/ng-data-access';
import { DiscussionPageComponent } from './discussion-page.component';

export const discussionRoutes: Routes = [
  {
    path: 'messages',
    title: 'Messagerie',
    canActivate: [userAuthGuard],
    component: DiscussionPageComponent,
  },
  {
    path: `messages/:${EtxeApiParams.DISCUSSION_ID}`,
    title: 'Discussion',
    canActivate: [userAuthGuard],
    component: DiscussionPageComponent,
  },
];
